import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL;
// console.log('API Base URL:', baseURL);
// console.log('All env vars:', import.meta.env);

const apiClient = axios.create({
  baseURL,
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;